import { createStore } from "vuex";
import modules from './modules/index'
export default createStore({
  modules
});
